<span mat-dialog-title>{{ 'Cambia password' | siaTranslate }}</span>

<mat-dialog-content>
  <form
    novalidate
    autocomplete="off"
    class="flex flex-col gap-1 pt-2 overflow-hidden"
  >
    <mat-form-field
      class="w-full mb-2 sia-login"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      <mat-label>{{ 'Nuova Password' | siaTranslate }}</mat-label>
      <input
        class="auth-input"
        matInput
        [type]="hideNewPassword() ? 'password' : 'text'"
        id="new-password"
        name="new-password"
        [ngModel]="newPassword()"
        (ngModelChange)="passwordChange($event)"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hideNewPasswordToggle($event)"
      >
        <mat-icon>{{
          hideNewPassword() ? 'visibility' : 'visibility_off'
        }}</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field
      class="w-full sia-login"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      <mat-label>{{ 'Conferma Password' | siaTranslate }}</mat-label>
      <input
        class="auth-input"
        matInput
        [type]="hideNewPasswordConfirmation() ? 'password' : 'text'"
        id="new-password-confirmation"
        name="new-password-confirmation"
        [ngModel]="newPasswordConfirmation()"
        (ngModelChange)="passwordConfirmationChange($event)"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hideNewPasswordConfirmationToggle($event)"
      >
        <mat-icon>{{
          hideNewPasswordConfirmation() ? 'visibility' : 'visibility_off'
        }}</mat-icon>
      </button>
    </mat-form-field>
    <ng-container
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{
        message: 'Lunghezza minima 8 caratteri',
        correct: minLength(),
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{
        message: 'Deve contenere almeno un numero',
        correct: hasNumber(),
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{
        message: 'Deve contenere almeno una lettera maiuscola',
        correct: hasCapitalCase(),
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{
        message: 'Deve contenere almeno una lettera minuscola',
        correct: hasSmallCase(),
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{
        message: 'Deve contenere almeno un carattere speciale',
        correct: hasSpecialCase(),
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{
        message: 'Le password devono essere uguali',
        correct: same(),
      }"
    ></ng-container>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-button
    [disabled]="
      !(
        hasCapitalCase() &&
        hasSmallCase() &&
        same() &&
        hasNumber() &&
        hasSpecialCase() &&
        minLength()
      )
    "
    (click)="updatePassword()"
    cdkFocusInitial
  >
    <mat-icon>check</mat-icon>
    {{ 'Salva' | siaTranslate }}
  </button>
  <button mat-button (click)="closeDialog()" class="error">
    <mat-icon>cancel</mat-icon>
    {{ 'Annulla' | siaTranslate }}
  </button>
</mat-dialog-actions>

<ng-template let-correct="correct" let-message="message" #info>
  <div
    class="flex flex-row items-center"
    [class]="correct ? 'text-success' : 'text-error'"
  >
    <mat-icon>
      {{ correct ? 'check_circle' : 'cancel' }}
    </mat-icon>
    <span> {{ message | siaTranslate }}</span>
  </div>
</ng-template>
